import { FC } from 'react';
import { Section } from './ui/Section';
import { EntryBlock } from './ui/EntryBlock';
import { Period } from './ui/Period';
import type { Entry } from '../types/cv';

interface Props {
  work: Entry[];
  title?: string;
  /** Projects keyed by the employer they were done under (Entry.entity). */
  engagements?: Record<string, Entry[]>;
  engagementsTitle?: string;
}

/**
 * A project carrying `entity` renders inside that job rather than in its own
 * section further down the page, so the evidence sits with the role it belongs to.
 */
export const WorkExperience: FC<Props> = ({
  work,
  title = 'Experience',
  engagements = {},
  engagementsTitle = 'Selected engagements',
}) => (
  <Section title={title}>
    {work.map((job, i) => {
      const key = job.company ?? job.name ?? '';
      const nested = engagements[key] ?? [];
      return (
        <EntryBlock
          key={`${key}-${i}`}
          entry={job}
          title={key}
          role={job.position}
          location={job.location}
          note={job.summary}
          grouped={nested.length > 0}
        >
          {nested.length > 0 && (
            <div className="cv-subentries">
              <h4 className="cv-subentries-title">{engagementsTitle}</h4>
              {nested.map((p, j) => (
                <div className="cv-subentry" key={`${p.name}-${j}`}>
                  <div className="cv-entry-head">
                    <h5 className="cv-suborg">{p.name}</h5>
                    <Period entry={p} />
                  </div>
                  {p.role && <p className="cv-role cv-sub">{p.role}</p>}
                  {p.summary && <p className="cv-note">{p.summary}</p>}
                </div>
              ))}
            </div>
          )}
        </EntryBlock>
      );
    })}
  </Section>
);

export default WorkExperience;
